<template>
    <div class="people">
        <slot>
            <div class="num fs14 Disp_AC" v-if="isMultiple" :class="{ has_people: id.length }">
                {{ id.length ? `${id.length}` : placeholder ? placeholder : $t('common.请选择') }}
            </div>
        </slot>
        <el-select
            :multiple="isMultiple"
            :multiple-limit="limit"
            class="People_Select"
            :style="{ opacity: onlyPop ? 0 : 1 }"
            :clearable="!onlyPop"
            collapse-tags
            :size="size"
            :no-data-text="noDataText || $t('common.暂无数据')"
            :popper-class="`People_Select_Popper ${onlyPop ? 'Only_Pop' : ''}`"
            v-model="id"
            :disabled="disabled"
            :value-key="itemValueType === 'Object' ? 'id' : 'value'"
            :placeholder="isMultiple ? '' : placeholder ? placeholder : $t('common.请选择')"
            @change="handleChange"
            @visible-change="$emit('visible-change', $event)"
        >
            <el-option class="no_checkbox filter_with_team" value="search">
                <el-input
                    class="No_Border"
                    style="width: 220px"
                    :placeholder="$t('club.搜索')"
                    v-model="localSearchName"
                    v-debounce="[searchLocalList, 'keydown', 300]"
                    @click.native.stop
                >
                    <i slot="prefix" class="el-input__icon el-icon-search" />
                </el-input>

                <ul class="team_wrapper SysFontM" v-if="teamList.length">
                    <li
                        class="team_item"
                        :class="{ active: activeId === item.id }"
                        v-for="(item, index) in teamList"
                        :key="index"
                        @click.stop="onTeamChange(item)"
                    >
                        {{ item.name }}
                    </li>
                </ul>
            </el-option>
            <el-option
                v-if="showSelectAll && limit === 0"
                class="Disp_AC no_checkbox"
                :class="{ selected: selectAll }"
                value="all"
            >
                <div class="select_all Disp_AC Bet pr20" @click="handleAll('div')">
                    {{ $t('common.全选') }}
                    <el-checkbox v-model="selectAll" @change="handleAll('checkbox')" @click.native.stop></el-checkbox>
                </div>
            </el-option>
            <el-option
                class="Disp_AC"
                v-for="(item, index) in copyPeopleList"
                :key="item.id + index"
                :disabled="currentDisabled(item)"
                :label="(item.number || '') + ' ' + (item['name' + $lang] || item.name)"
                :value="itemValueType === 'Object' ? item : item.id"
                v-show="activeId === item.teensCampTeamId"
            >
                <cl-avatar v-if="showAvatar" :src="item.avatar" width="32" height="32"></cl-avatar>
                <span
                    v-if="showPlayerStatus"
                    class="ml12 Text_Over"
                    style="max-width:150px;"
                    :title="item['name' + $lang] || item.name"
                    :class="{ red: item.injury && !item.teamTraining, green: item.injury && item.teamTraining }"
                >
                    {{ item.number }} {{ item['name' + $lang] || item.name }}
                </span>
                <span v-else class="ml12 Text_Over" style="max-width:150px;" :title="item['name' + $lang] || item.name">
                    {{ item.number }} {{ item['name' + $lang] || item.name }}
                </span>
            </el-option>
        </el-select>
    </div>
</template>

<script>
/**
 * ComponentName: people list
 * Created Date:2022/4/24
 * Author: Nancy
 * Modify: shishuo·zhang 2022/4/28
 * Modify: 张钧 2022/8/2 列表本地搜索
 * Modify: 张钧 2022/8/16 带梯队的球员选择器
 * 组件说明：
 * 这组组件是选球员、教练的组件，支持单选，多选
 * eg:
 *     <cl-people-with-team></cl-people-with-team>
 */
export default {
    name: 'cl-people-with-team',
    model: {
        prop: 'value',
        event: 'change',
    },
    data() {
        return {
            id: JSON.parse(JSON.stringify(this.value)) || (this.isMultiple ? [] : ''),
            localSearchName: '', // 本地搜索名称
            copyPeopleList: [], // 人员列表副本
            activeId: '', // 选中的梯队id
            selectAll: false, // 全选
        }
    },
    watch: {
        value: {
            handler() {
                this.id = JSON.parse(JSON.stringify(this.value))
            },
            deep: true,
        },

        peopleList: {
            immediate: true,
            handler() {
                this.copyPeopleList = this.peopleList
                this.handleShowAllChecked()
            },
        },

        teamList: {
            immediate: true,
            handler(newV) {
                if (newV[0]) {
                    this.activeId = newV[0].id
                }
            },
        },

        activeTeamId(newV) {
            if (newV) {
                this.activeId = newV
            }
        },
    },

    props: {
        value: {
            type: [String, Array],
            default: '',
        },
        type: {
            type: String,
            default: 'single',
        },
        list: {
            type: Array,
            default: () => [],
        },
        teamList: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: '',
        },
        onlyPop: {
            type: Boolean,
            default: false,
        },
        // 是否显示头像
        showAvatar: {
            type: Boolean,
            default: true,
        },
        // 是否显示球员在队/伤病状态
        showPlayerStatus: {
            type: Boolean,
            default: true,
        },
        // 自定义禁用选项
        customDisabled: {
            type: Array,
            default: () => [],
        },
        //  限制多选的数量 多选时用户最多可以选择的项目数，为 0 则不限制
        limit: {
            type: Number,
            default: 0,
        },
        // 无数据时显示的文字
        noDataText: {
            type: String,
            default: '',
        },
        // select组件option的value类型 Object|绑定的是item String|绑定的是string
        itemValueType: {
            type: String,
            default: 'Object',
        },
        // 选中的teamId
        activeTeamId: {
            type: String,
        },
        // placeholder
        placeholder: {
            type: String,
        },
        selectAllOption: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        peopleList() {
            return JSON.parse(JSON.stringify(this.list))
        },
        isMultiple() {
            // 多选
            return this.type === 'multiple'
        },
        isSingle() {
            // 单选
            return this.type === 'single'
        },
        injuryNum() {
            let num = this.list.filter((item) => item.injury && !item.teamTraining)
            return num.length
        },
        showSelectAll() {
            // 是否显示全选
            return (
                this.selectAllOption &&
                this.copyPeopleList.filter((item) => this.activeId === item.teensCampTeamId).length
            )
        },
    },
    methods: {
        handleAll(fromNode) {
            if (fromNode === 'div') {
                this.selectAll = !this.selectAll
            }
            let items = []
            if (this.selectAll) {
                // 全选梯队人员
                const arr = this.copyPeopleList.filter((item) => {
                    if (this.showPlayerStatus) {
                        // 显示球员状态时，不筛选带病随队
                        return item.teensCampTeamId === this.activeId && !(item.injury && !item.teamTraining)
                    } else {
                        return item.teensCampTeamId === this.activeId
                    }
                })
                const players = []
                const ids = this.id.map((item) => item.id)
                arr.forEach((item) => {
                    if (!ids.includes(item.id)) {
                        players.push(item)
                    }
                })

                if (this.itemValueType === 'Object') {
                    this.id.push(...players)
                } else {
                    this.id.push(...players.map((item) => item.id))
                }
            } else {
                // 清空梯队全选
                const arr = []
                this.copyPeopleList.forEach((item) => {
                    if (item.teensCampTeamId === this.activeId) {
                        arr.push(item.id)
                    }
                })
                this.id = this.id.filter((item) => !arr.includes(this.itemValueType === 'Object' ? item.id : item))
            }
            this.$emit('change', this.id, items)
        },
        handleChange() {
            if (this.id.indexOf('all') > -1) {
                // 有全选项
                let index1 = this.id.indexOf('all')
                index1 > -1 && this.id.splice(index1, 1)
            }
            if (this.id.indexOf('search') > -1) {
                // 有全选项
                let index2 = this.id.indexOf('search')
                index2 > -1 && this.id.splice(index2, 1)
            }
            this.handleShowAllChecked()

            let items = []
            this.list.map((item) => {
                if (this.id.indexOf(item.id) > -1) {
                    items.push(item)
                }
            })
            this.$emit('change', this.id, items)
        },

        // 显示全选状态
        handleShowAllChecked() {
            let currentTeamPeopleNum = 0 // 当前梯队的人员总数
            let selectSum = 0 // 当前梯队已选的人员总数

            this.peopleList.forEach((item) => {
                if (item.teensCampTeamId === this.activeId) {
                    // 如果球员的梯队id，等于当前选中的梯队id
                    currentTeamPeopleNum++
                    if (this.itemValueType === 'Object') {
                        const obj = this.id.find((item2) => item2.id === item.id)
                        if (obj) {
                            selectSum++
                        }
                    } else {
                        if (this.id.includes(item.id)) {
                            selectSum++
                        }
                    }
                }
            })

            this.selectAll = currentTeamPeopleNum > 0 && selectSum >= currentTeamPeopleNum
        },

        // 当前禁用项
        currentDisabled(item) {
            let disable = false
            if (this.customDisabled && this.customDisabled.length) {
                // 是否是自定义禁用
                disable = this.customDisabled.includes(item.id)
            } else {
                disable = item.injury && !item.teamTraining && this.showPlayerStatus
            }
            return disable
        },
        // 梯队change时，
        onTeamChange(item) {
            if (this.activeId !== item.id) {
                this.activeId = item.id
                this.handleShowAllChecked()
                this.$emit('change-team', item.id)
            }
        },
        // 从本地搜索
        searchLocalList(searchName) {
            if (!searchName) {
                this.copyPeopleList = JSON.parse(JSON.stringify(this.peopleList))
            } else {
                this.copyPeopleList = this.peopleList.filter((item) => {
                    return (item['name' + this.$lang] || item.name).includes(searchName)
                })
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.red {
    color: $base-font-error;
}

.green {
    color: $base-color-success;
}

.people {
    display: inline-block;
    position: relative;

    .num {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        font-size: 14px;
        z-index: 1;
        padding: 0 12px;
        box-sizing: border-box;
        color: $base-font-minor;
        background: rgba(251, 253, 255, 0.8);
        font-family: SysFontR;
        border-radius: 6px;
    }

    .has_people {
        font-size: 16px;
        color: $base-font-major;
        font-family: AkrobatMedium;
    }

    .People_Select {
        position: relative;
        z-index: 2;
    }
}
</style>

<style lang="scss">
.filter_with_team {
    height: 90px !important;
    padding: 0 !important;
    &:hover {
        background: none !important;
    }
    &.hover {
        background: none !important;
    }
    .el-input__inner {
        border-radius: 0;
        background: none;
        border: none;
        border-bottom: 1px solid #e4ecf5 !important;
    }
}
.team_wrapper {
    display: flex;
    align-items: center;
    width: 220px;
    height: 50px;
    overflow-x: auto;
    .team_item {
        padding: 3px 8px;
        height: 23px;
        margin-right: 16px;
        line-height: 23px;
        font-size: 12px;
        color: #81818a;
        &.active {
            color: #fff;
            background: #3663e1;
            border-radius: 32px;
        }
    }
}

.select_all {
    position: absolute;
    top: 0;
    right: 0;
    left: 8px;
    height: 100%;
    z-index: 5;
    color: #81818a;
}

.no_checkbox {
    &::after {
        display: none;
    }
}
</style>
